// @ts-strict
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
} from '@angular/core';
import { LMDrillAroundNode } from '@components/drillaround/lm-drill-around-wc';
import { IdsTreeNodeData } from "ids-enterprise-wc/components/ids-tree/ids-tree-node";

@Component({
  selector: 'lm-drill-point-list',
  standalone: false,
  templateUrl: './lm-drill-point-list.component.html',
  styleUrls: [ './lm-drill-point-list.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
  })
export class LMDrillPointListComponent implements OnInit {

  @Input() info!: LMDrillAroundViewInfo;
  @Input() selectedNode!: LMDrillAroundNode;

  @Output() drillPointSelected = new EventEmitter<LMDrillAroundNode>();

  gridOptions!: SohoDataGridOptions;

  constructor(private ngZone: NgZone) {}

  ngOnInit() {
    this.gridOptions = this.buildGridOptions();
  }

  LMDrillAroundClickFunction = (e: Event, args: SohoDataGridColumnClickData[]) => {
    this.ngZone.run(() => {
      this.drillPointSelected.emit(args[0].item);
    });
  };

  private buildGridOptions(): SohoDataGridOptions {
    const gridColumns = this.buildGridColumns();

    // --------------------------------------------------
    // build grid data from the tree data node.
    // --------------------------------------------------
    let gridData: IdsTreeNodeData[] = [];
    if (this.selectedNode.children) {
      // ----------------------------------------------------------------------------------------------------
      // for some reason the datagrid will attempt to display all the selectedNode.childrens ancestors.
      // mapping the selectedNode.children to a new set of objects w/o each child's children.
      // ----------------------------------------------------------------------------------------------------
      gridData = this.selectedNode.children.map(node => {
        // ----------------------------------------------------------------------------------------------------
        // only mapping what is needed to display in the datagrid and for the
        // event handler in lm-drill-around.component:onViewDrillPointSelected
        // ----------------------------------------------------------------------------------------------------
        const drillAroundNode = node as LMDrillAroundNode;
        const cellText = this.info.type === 'panel' ? drillAroundNode.dataView?.representativeText : drillAroundNode.text;
        return {
          id: drillAroundNode.id,
          lmParent: drillAroundNode.lmParent,
          text: cellText
        };
      });
    }

    return {
      columns: gridColumns,
      dataset: gridData,
      selectable: 'single',
      paging: false,
      filterable: false,
      rowHeight: 'extra-small',
      isList: true,
      emptyMessage: null,
      enableTooltips: true,
      columnSizing: 'header',
      stretchColumn: 'last'
    } as SohoDataGridOptions;
  }

  private buildGridColumns(): SohoDataGridColumn[] {
    const drillArrowColumn: ListGridColumn = {
      id:        'drill-around',
      name:      Soho.Locale.translate('Select'),
      sortable:  false,
      resizable: false,
      formatter: Soho.Formatters.Button,
      icon:      'drill',
      click:     this.LMDrillAroundClickFunction,
      align:     'center'
    };

    // if the selected node is a panel, then the children of this node are records
    const headerText = this.info.type === 'panel' ? Soho.Locale.translate('Record') : Soho.Locale.translate('DrillPoint');

    const drillPointTitleColumn: ListGridColumn = {
      id: 'name',
      name: headerText,
      field: 'text',
      formatter: Soho.Formatters.Text
    };

    return [
      drillArrowColumn,
      drillPointTitleColumn
    ];
  }
}
